import type { ActivityEntryProperties } from "../raw/ActivityEntryRawEvent";

export enum RbcActivityEntryEventName {
  activities_entry = "activities_entry",
}

export interface ActivityEntryEvent {
  name: RbcActivityEntryEventName.activities_entry;
  properties: ActivityEntryProperties;
}
